import LoadingIndicator from "../../components/shared/LoadingIndicator";
import { useAuth } from "../../contexts/AuthContext";

/**
 * RequireAuth Wrapper
 *
 * Protects routes that require a user session.
 * - Shows loading state while checking session
 * - Redirects to /login if not authenticated, saving current location
 * - Renders children if authenticated
 */
interface RequireAuthProps {
    children: JSX.Element;
}

export default function RequireAuth({ children }: RequireAuthProps) {
    const { user, loading } = useAuth();
    // const location = useLocation();

    if (loading) {
        return <LoadingIndicator text="Checking session..." />;
    }

    if (!user) {
        const authUrl = import.meta.env.VITE_AUTH_URL || window.location.origin;
        window.location.href = `${authUrl}/${window.location.search}`;
    }

    return children;
}
